import { createStore, applyMiddleware, compose, combineReducers } from 'redux'
import thunkMiddleware from 'redux-thunk'
import history from '../history'
import rootReducer from 'services/rootReducer'
import promiseMiddleware from 'application/middleware/promiseMiddleware'
import localCacheMiddleware from 'application/middleware/localCacheMiddleware'
import devToolsMiddleware from 'application/middleware/devToolsExtension'
import { notificationMiddleware } from 'application/middleware/notificationMiddleware'
import unauthorizedMiddleware from 'application/middleware/unauthorizedMiddleware'
import actionListenerStoreEnhancer from './actionListenerStoreEnhancer'
import throttleMiddleware from 'application/middleware/reduxThrottle'
import { connectRouter, routerMiddleware } from 'connected-react-router'

export default function configureStore (initialState, apis = {}) {
  const middleware = [
    thunkMiddleware.withExtraArgument(apis),
    localCacheMiddleware(initialState.bootup.localCacheNonce),
    promiseMiddleware,
    throttleMiddleware,
    unauthorizedMiddleware,
    notificationMiddleware,
    routerMiddleware(history),
  ]
  const store = createStore(
    connectRouter(history)(combineReducers(rootReducer)),
    initialState,
    compose(
      applyMiddleware(...middleware),
      actionListenerStoreEnhancer,
      devToolsMiddleware()
    ),
  )

  return store
}
